module.exports = __webpack_public_path__ + "img/THEOS_LOGO_METAL.d22967f3.png";